/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolDirectionsBusIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-directions-bus"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M7.95 19.45L7.95 19.75Q7.95 20.48 7.46 20.96Q6.97 21.45 6.25 21.45Q5.53 21.45 5.04 20.96Q4.55 20.48 4.55 19.75L4.55 18.25Q4.1 17.68 3.88 17.05Q3.65 16.43 3.65 15.75L3.65 5.95Q3.65 3.67 5.61 2.66Q7.58 1.65 12 1.65Q16.43 1.65 18.39 2.66Q20.35 3.67 20.35 5.95L20.35 15.75Q20.35 16.43 20.13 17.05Q19.9 17.68 19.45 18.25L19.45 19.75Q19.45 20.48 18.96 20.96Q18.48 21.45 17.75 21.45Q17.02 21.45 16.54 20.96Q16.05 20.48 16.05 19.75L16.05 19.45ZM5.9 9.85L18.1 9.85L18.1 7.1L5.9 7.1ZM8.45 16.3Q8.45 16.3 8.79 16.3Q9.13 16.3 9.61 15.81Q10.1 15.32 10.1 14.65Q10.1 13.97 9.61 13.49Q9.13 13 8.45 13Q7.78 13 7.29 13.49Q6.8 13.97 6.8 14.65Q6.8 15.32 7.29 15.81Q7.78 16.3 8.45 16.3ZM15.55 16.3Q15.55 16.3 15.89 16.3Q16.23 16.3 16.71 15.81Q17.2 15.32 17.2 14.65Q17.2 13.97 16.71 13.49Q16.23 13 15.55 13Q14.88 13 14.39 13.49Q13.9 13.97 13.9 14.65Q13.9 15.32 14.39 15.81Q14.88 16.3 15.55 16.3Z" fill={color} />
    </svg>
  );
}
